import { Alert, Box, Button, Paper, Typography } from "@mui/material";
import { useAuthenticatedUser } from "../../src/store";
import { useI18n } from "../../src/ui/hooks/useI18n";
import { PageLayout } from "../../src/ui/layout/PageLayout";

export function AccountActivation({ title }: { title: string }) {
  const { t } = useI18n();
  const currentUser = useAuthenticatedUser();

  return (
    <PageLayout title={t(title)}>
      <Paper sx={{ maxWidth: "sm", margin: "auto", padding: { xs: 4, sm: 6 } }}>
        <Alert severity="success">{t("verification.alertMessage")}</Alert>

        <Typography variant="body2" sx={{ my: 2, textAlign: "justify" }}>
          {t("verification.text1")}
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: 2, textAlign: "justify" }}>
          {t("verification.text2")}
        </Typography>
        <Box sx={{ display: "flex", width: "100%", justifyContent: "center", mt: 4 }}>
          <Button
            href={`https://support-cvnpro.mesvaccins.net/hc/fr/requests/new?ticket_form_id=13324704761361&tf_anonymous_requester_email=${
              currentUser?.email
            }${
              currentUser?.mobileNumber ? `&tf_13137831594129=${currentUser?.mobileNumber}` : ""
            }&tf_subject=Demande d’approbation du compte&tf_description=Envoi de la preuve de profession.`}
            target="_blank"
            variant="contained"
            disableElevation
          >
            {t("verification.cta")}
          </Button>
        </Box>
      </Paper>
    </PageLayout>
  );
}